import styled from 'styled-components';
import { Button } from '../../../../components/common/buttons/Button';
import { usePopup } from '../../../../hooks/popup/usePopup';
import { postMessageToRN } from '../../../../utils/RNCommunicator/postMessageToRN.util';

interface ProductDetailPageFooterProps {
  children: JSX.Element;
}

export const ProductDetailPageFooter = ({ children }: ProductDetailPageFooterProps) => {
  const Popup = usePopup();

  const handleShareButtonClick = () => {
    if (window.ReactNativeWebView) {
      postMessageToRN({ messageKey: 'share', messageParam: window.location.href });
    } else {
      window.navigator.clipboard.writeText(window.location.href);
      Popup.toast('현재 게시물의 주소가 복사되었습니다.');
    }
  };

  return (
    <Container>
      <BlurSection />

      <ButtonSection>
        <ButtonContainer>
          <MoreButtonWrapper>
            <Button
              borderType={'square'}
              color={'outlinedGreyLight'}
              size={'lg'}
              icon={{ fileName: 'Link', size: 'Large', fill: '#858894', position: 'left' }}
              onClick={() => handleShareButtonClick()}
            />
          </MoreButtonWrapper>

          {children}
        </ButtonContainer>
      </ButtonSection>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  max-width: 512px;
  min-height: 55px;

  display: flex;
  padding: 0px 16px 32px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 100px;
  align-self: stretch;

  position: fixed;
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);

  background-color: #fff;
`;

const ButtonSection = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 100px;
`;

const MoreButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const BlurSection = styled.div`
  width: 100%;
  max-width: 512px;
  height: 40px;

  display: flex;
  padding: var(--radius-large, 16px);
  justify-content: center;
  align-items: center;
  gap: var(--radius-small, 4px);

  position: absolute;
  left: 0px;
  top: -40px;

  border-radius: var(--radius-none, 0px);
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 63.96%);
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  align-self: stretch;
`;
